import { useEffect } from "react";

declare global {
  interface Window {
    gtranslateSettings?: Record<string, unknown>;
  }
}

/**
 * Loads the GTranslate popup widget AFTER React mounts, so the wrapper element
 * exists when the external script initializes.
 */
export function GTranslateWidget() {
  useEffect(() => {
    const wrapper = document.querySelector(".gtranslate_wrapper");
    if (!wrapper) return;

    window.gtranslateSettings = {
      default_language: "es",
      native_language_names: true,
      detect_browser_language: true,
      wrapper_selector: ".gtranslate_wrapper",
      alt_flags: { en: "usa" },
    };

    const scriptId = "gtranslate-popup-js";
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://cdn.gtranslate.net/widgets/latest/popup.js";
    script.defer = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
